import {Component, inject, input, ViewEncapsulation} from '@angular/core';
import {ProcessOverviewStore} from '../../service/process-overview.store';
import {CrewDetailsComponent} from './crew-details/crew-details.component';
import {OrdinanceDetailComponent} from './ordinance-detail/ordinance-detail.component';

@Component({
  selector: 'kpi4me-crew-detail',
  templateUrl: './crew-detail.component.html',
  styleUrls: ['./crew-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [OrdinanceDetailComponent, CrewDetailsComponent]
})
export class CrewDetailComponent {
  private _processOverviewService = inject(ProcessOverviewStore);
  selectedCart = this._processOverviewService.selectedCart;
  showImports = input<boolean>(true);
}
